export enum ExpirationNotificationEnum {
  ExpiresWithin30Days = 'ExpiresWithin30Days',
  ExpiresWithin60Days = 'ExpiresWithin60Days',
}
